import React from "react";
import { Box, Typography } from "@mui/material";

import halfCircles from "../../assets/half-circles.png";

const Banner = ({ title, description, image }) => {
  return (
    <Box
      sx={{
        width: "100%",

        height: {
          xs: "420px",
          customBreakpoint: "350px",
        },

        background: "linear-gradient(180deg, #0624BE 0%, #2A2177 100%)",

        position: "relative",
        overflow: "hidden",

        display: "flex",

        flexDirection: {
          xs: "column",
          customBreakpoint: "row",
        },

        alignItems: "center",
        justifyContent: "space-between",

        // px: {
        //   xs: "16px",
        //   sm: "24px",
        //   md: "84px",
        // },

        pl: {
          xs: "16px",
          customBreakpoint: "24px",
          md: "84px",
        },

        pr: {
          xs: "16px",
          customBreakpoint: "24px",
          md: "189px",
        },

        py: {
          xs: "48px",
          customBreakpoint: "60px",
        },
      }}
    >
      {/* LEFT CONTENT */}
      <Box
        sx={{
          flex: 1,

          zIndex: 2,

          minWidth: 0,

          textAlign: {
            xs: "center",
            customBreakpoint: "left",
          },

          mb: {
            xs: "42px",
            customBreakpoint: 0,
          },

          pr: {
            customBreakpoint: "24px",
            md: "40px",
          },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "2.5rem",
            fontWeight: 700,
            color: "#ffffff",
            lineHeight: 1.3,
            mb: 2,
            "@media (max-width: 1200px)": {
              fontSize: "1.75rem",
              fontWeight: "semiBold",
            },
            "@media (max-width: 780px)": {
              fontSize: "1.5rem",
              mb: 1,
            },
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 400,
            color: "#ffffff",
            lineHeight: 1.7,
            maxWidth: "624px",
            "@media (max-width: 1200px)": {
              fontSize: "18px",
            },
            "@media (max-width: 780px)": {
              fontSize: "16px",
              mb: 2,
            },
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* RIGHT SIDE */}
      <Box
        sx={{
          flex: 1,

          minWidth: 0,

          position: "relative",

          display: "flex",
          alignItems: "center",

          justifyContent: {
            xs: "center",
            customBreakpoint: "flex-end",
          },

          flexShrink: 0,

          width: "100%",
        }}
      >
        {/* HALF CIRCLES */}
        <Box
          component="img"
          src={halfCircles}
          aria-hidden="true"
          sx={{
            position: "absolute",

            width: {
              xs: "370px",
              customBreakpoint: "480px",
              md: "599px",
            },

            height: {
              xs: "216px",
              customBreakpoint: "300px",
              md: "350px",
            },

            objectFit: "contain",

            right: {
              xs: "50%",
              customBreakpoint: "-100px",
              md: "-140px",
            },

            bottom: {
              xs: "-15px",
              customBreakpoint: "-55px",
              md: "-20px",
            },

            transform: {
              xs: "translateX(50%)",
              customBreakpoint: "none",
            },

            zIndex: 0,
          }}
        />

        {/* MAIN IMAGE */}
        <Box
          component="img"
          src={image}
          sx={{
            position: "relative",

            zIndex: 1,

            width: {
              xs: "252px",
              customBreakpoint: "405px",
              md: "495px",
            },

            height: {
              xs: "168px",
              customBreakpoint: "270px",
              md: "330px",
            },

            objectFit: "contain",

            display: "block",

            maxWidth: "100%",

            mr: {
              xs: 0,
              md: "-20px",
            },
          }}
        />
      </Box>
    </Box>
  );
};
export default Banner;
